export const opensInNewTab = (href: string) => /^https?:\/\//.test(href);

export const getLinkTargetProps = (href: string) =>
  opensInNewTab(href) ? { target: '_blank', rel: 'noreferrer' } : {};
